<template>
  <theme-comp-switch
    :defaultComp="defaultErrorPage"
    :lalamoveComp="lalamoveErrorPage"
  >
    <div>{{ $t('act_risk_error') }}</div>
    <div class="errorTip">{{ $t('act_risk_error_tip') }}</div>
  </theme-comp-switch>
</template>

<script>
export default {
  mounted() {
    this.$emit('reportEvent', {
      event: 'abnormal_page_expo',
      page_name: 'risk_page'
    });
  },
  data() {
    return {
      defaultErrorPage: () => import('@/components/templates/common/ErrorPage'),
      lalamoveErrorPage: () =>
        import('@/components/templates/common/LalamoveErrorPage')
    };
  }
};
</script>

<style lang="less" scoped>
.errorTip {
  font-size: 24px;
}
</style>
